// extracted by mini-css-extract-plugin
export default {"tabs_container":"volunteerstudyhistory_tabs_container__yq5dK","tab_btn":"volunteerstudyhistory_tab_btn__3mQCA","active":"volunteerstudyhistory_active__8X2Cu"};